export default {
  SET_REASONS(state, reasons) {
    state.reasons = reasons
  }
}
